import { findIndex } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  open: false,
  description: "",
};

export function PosterReducer(state = { posters: [] }, action) {
  let currentPoster;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_POSTER" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("posters")){
          currentPoster = state.protocolSection.scene.apparatus.posters[findIndex(state.protocolSection.scene.apparatus.posters, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_POSTER':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("posters")){
            protocolSection.scene.apparatus.posters = [ ...protocolSection.scene.apparatus.posters, newObj ]
          } else {
            protocolSection.scene.apparatus.posters = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "UNDO":
            //Payload = {lastState}

            if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('posters')) {

              protocolSection.scene.apparatus.posters = action.payload.lastState.scene.apparatus.posters

              return { ...state, ...{
                protocolSection: protocolSection
              } }

            } else {
              return state;
            }

        default:
            return state;
    }
}
